import type { ReactNode } from 'react';
import { Link, type To } from 'react-router';

import styles from './styles.module.scss';

interface Props {
  children: ReactNode;
  onClick?: () => void;
  to?: To;
  variant?: 'primary' | 'secondary' | 'simple';
  _blank?: boolean;
  textColor?: string;
}

export function Button({ children, to, onClick, variant = 'primary', _blank = false, textColor }: Props) {
  if (to) {
    return (
      <Link
        className={`${styles.btn} ${styles[variant]}`}
        to={to}
        target={_blank ? '_blank' : undefined}
        style={textColor ? { color: textColor } : undefined}>
        {children}
      </Link>
    );
  }

  return (
    <button
      className={`${styles.btn} ${styles[variant]}`}
      onClick={onClick}
      style={textColor ? { color: textColor } : undefined}>
      {children}
    </button>
  );
}
